import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { type AmcInstanceCreationRequestBody } from "../../../zodios/apiDefinitions/amc";
import { amcInstanceCreationRequestsQueryKey } from "./useAMCInstanceCreationRequest";

/** Resends an AMC instance creation request with a new set of advertisers to add and remove. */
export function useUpdateAMCInstanceRequest() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ requestId, body }: { requestId: number; body: AmcInstanceCreationRequestBody }) =>
      await apiClient.updateAMCInstanceCreationRequest(body, { params: { requestId } }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: amcInstanceCreationRequestsQueryKey });
    },
  });
}
